declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined;

export function initAnalytics() {
  if (typeof window === 'undefined' || !GA_ID || GA_ID.length < 4) return;
  if (document.getElementById('ga4-script')) return;

  const s = document.createElement('script');
  s.id = 'ga4-script';
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer!.push(args);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { anonymize_ip: true });
}

export function trackPageview(path: string) {
  if (!GA_ID || !window.gtag) return;
  window.gtag('event', 'page_view', { page_path: path });
}

export function trackEvent(name: string, params?: Record<string, string>) {
  if (!GA_ID || !window.gtag) return;
  window.gtag('event', name, params);
}

export function injectGscVerification() {
  const content = import.meta.env.VITE_GSC_VERIFICATION as string | undefined;
  if (!content || typeof document === 'undefined') return;
  if (document.querySelector('meta[name="google-site-verification"]')) return;
  const meta = document.createElement('meta');
  meta.name = 'google-site-verification';
  meta.content = content;
  document.head.appendChild(meta);
}
